var _excluded = ["isScrollable", "children"],
    _excluded2 = ["selectedTabIndex", "startIndex", "tabs", "tabProps", "onTabChange", "orientation", "children", "isScrollable", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Div } from '@kizi/core-components';
import React, { useEffect, useMemo, useState } from 'react';
import { IconV2 } from './IconV2';

var Tab = function Tab(_ref) {
  var _ref$isScrollable = _ref.isScrollable,
      isScrollable = _ref$isScrollable === void 0 ? false : _ref$isScrollable,
      children = _ref.children,
      divProps = _objectWithoutProperties(_ref, _excluded);

  var ref = React.useRef(null);

  var center = function center() {
    var _ref$current;

    ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollIntoView({
      behavior: 'smooth',
      inline: 'center'
    });
  };

  React.useLayoutEffect(function () {
    if (isScrollable && ref && ref.current) {
      ref.current.addEventListener('click', center);
    }

    return function () {
      if (ref && ref.current) {
        ref.current.removeEventListener('click', center);
      }
    };
  }, [ref.current]);
  return /*#__PURE__*/React.createElement(Div, _extends({
    ref: ref
  }, divProps), children);
};

export var TabView = function TabView(_ref2) {
  var selectedTabIndex = _ref2.selectedTabIndex,
      startIndex = _ref2.startIndex,
      tabs = _ref2.tabs,
      tabProps = _ref2.tabProps,
      onTabChange = _ref2.onTabChange,
      orientation = _ref2.orientation,
      children = _ref2.children,
      _ref2$isScrollable = _ref2.isScrollable,
      isScrollable = _ref2$isScrollable === void 0 ? false : _ref2$isScrollable,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? false : _ref2$icon,
      divProps = _objectWithoutProperties(_ref2, _excluded2);

  var _useState = useState(startIndex !== null && startIndex !== void 0 ? startIndex : 0),
      _useState2 = _slicedToArray(_useState, 2),
      innerSelectedTabIndex = _useState2[0],
      setInnerSelectedTabIndex = _useState2[1];

  useEffect(function () {
    if (selectedTabIndex !== undefined && selectedTabIndex > -1) {
      setInnerSelectedTabIndex(selectedTabIndex);
    }
  }, [selectedTabIndex]);
  var Tabs = useMemo(function () {
    return tabs.map(function (tabDef, i) {
      var _tabProps$css;

      var isSelected = innerSelectedTabIndex === i;

      var _tabProps = tabProps instanceof Function ? tabProps(isSelected, {
        disabled: tabDef.disabled === true,
        index: i
      }) : tabProps !== null && tabProps !== void 0 ? tabProps : {};

      var css = (_tabProps$css = _tabProps.css) !== null && _tabProps$css !== void 0 ? _tabProps$css : {};
      return /*#__PURE__*/React.createElement(Tab, _extends({
        display: " flex",
        "align-items": "center",
        "justify-content": "center",
        key: 'tab-' + i,
        css: _objectSpread({
          cursor: 'pointer'
        }, css)
      }, _tabProps, {
        onClick: function onClick(e) {
          if (_tabProps !== null && _tabProps !== void 0 && _tabProps.onClick) {
            _tabProps === null || _tabProps === void 0 ? void 0 : _tabProps.onClick(e);
          }

          if (tabDef.disabled !== true) {
            if (onTabChange) {
              onTabChange(i);
            }

            setInnerSelectedTabIndex(i);
          }
        },
        isScrollable: isScrollable
      }), tabDef.label, icon && (isSelected && selectedTabIndex !== -1 ? /*#__PURE__*/React.createElement(IconV2, {
        width: 16,
        height: 16,
        name: "carret-up",
        fill: "#2B2F3B"
      }) : /*#__PURE__*/React.createElement(IconV2, {
        width: 16,
        height: 16,
        name: "carret-down",
        fill: "#2B2F3B"
      })));
    });
  }, [tabs, innerSelectedTabIndex, setInnerSelectedTabIndex, tabProps]);
  var TabContents = useMemo(function () {
    return tabs.map(function (tabDef) {
      return tabDef.content;
    });
  }, [tabs]);
  return /*#__PURE__*/React.createElement(Div, divProps, children(Tabs, TabContents[innerSelectedTabIndex]));
};